// extracted by mini-css-extract-plugin
export default {"sidenav":"SideNav_sidenav__3e+lL","mainMenu":"SideNav_mainMenu__MsAOi","divider":"SideNav_divider__vcy74","spacer":"SideNav_spacer__tpwVI"};